import { Category } from '@/interfaces';

export const caseCategoryColorBg = (type: Category): string => {
	const colors: Record<Category, string> = {
		Whistleblower: 'bg-[#FF004333]',
		Commodities: 'bg-[#C0D65333]',
		'Health Care': 'bg-[#2084E726]',
		Securities: 'bg-[#EB35CE33]',
		Antitrust: 'bg-[#40BB7126]',
		Commercial: 'bg-[#2D41F54D]',
		'Data Privacy': 'bg-[#FD983440]',
		'Consumer Protection': 'bg-[#8F20EF33]',
	};
	return colors[type];
};

export const caseCategoryColorText = (type: Category): string => {
	const colors: Record<Category, string> = {
		Whistleblower: '!text-[#FF0043]',
		Commodities: '!text-[#A0B245]',
		'Health Care': '!text-[#2084E7]',
		Securities: '!text-[#EB35CE]',
		Antitrust: '!text-[#40BB71]',
		Commercial: '!text-[#2D41F5]',
		'Data Privacy': '!text-[#FD9834]',
		'Consumer Protection': '!text-[#8F20EF]',
	};
	return colors[type];
};
